import configButtons from '../tokens/buttons.json';
import configLink from '../tokens/link.json';
import configModal from '../tokens/modal.json';
const mainClass = `${configModal.class}`;
const classes = `${mainClass}`;
const overflowClass = `${mainClass}${configModal.overflow}`;
const dialogClass = `${mainClass}${configModal.dialog}`;
const headerClass = `${mainClass}${configModal.header}`;
const titleClass = `${mainClass}${configModal.title}`;
const closeClass = `${mainClass}${configModal.close}`;
const closeTextClass = `${closeClass}${configModal.text}`;
const bodyClass = `${mainClass}${configModal.body}`;
const contentClass = `${mainClass}${configModal.content}`;
const headingClass = `${mainClass}${configModal.heading}`;
const footerClass = `${mainClass}${configModal.footer}`;
const overlayClass = `${mainClass}${configModal.overlay}`;
const mainButtonClass = `${configButtons.class}`;
const labelButtonClass = `${mainButtonClass}${configButtons.label}`;
const mainLinkClass = `${configLink.class}`;
export const overlayTemplate = `<div id="js-modal-overlay" class="${overlayClass}" tabindex="-1" role="dialog" aria-hidden="true"></div>`;
export const ModalTemplate = `
{{##def.scrollable:
	{{? it.scrollable && it.scrollable == true}}
    ${overflowClass}
	{{?}}
#}}

{{##def.classContent:
	{{? it.classContent}}
    {{=it.classContent}}
	{{?}}
#}}

<div id="js-{{=it.id}}" class="${classes} {{#def.scrollable}} {{#def.classContent}}" tabindex="-1" role="dialog" aria-labelledby="{{=it.id}}" aria-hidden="true">
<div class="${dialogClass}" role="document">
    <header class="${headerClass}">
    {{##def.headingTitle:{{? it.content.title.heading}}h{{=it.content.title.heading}}{{??}}h2{{?}}#}}

    <{{#def.headingTitle}} id="{{=it.id}}" class="${titleClass}">{{=it.content.title.text}}</{{#def.headingTitle}}>
        <button class="js-modal-close ${closeClass}" type="button" role="button">
            <span class="${closeTextClass}">Fermer</span>
        </button>
    </header>
    <main class="${bodyClass}">
      {{##def.tag:{{? it.content.subTitle}}article{{??}}div{{?}}#}}

      <{{#def.tag}} class="${contentClass}">
        {{##def.headingSubtitle:{{? it.content.subTitle.heading}}h{{=it.content.subTitle.heading}}{{??}}h3{{?}}#}}
        {{? it.content.subTitle}}
          <{{#def.headingSubtitle}} class="${headingClass}">{{=it.content.subTitle.text}}</{{#def.headingSubtitle}}>
        {{?}}
        <div class="mt-body-m">{{=it.content.contentHTML}}</div>
      </{{#def.tag}}>
    </main>
    <footer class="${footerClass}">
        <button type="button" class="${mainButtonClass} js-modal-first-cta">
            <span class="${labelButtonClass}">{{=it.content.footer.fstCta.label}}</span>
        </button>

        {{? it.content.footer.sndCta}}
          {{? it.content.footer.sndCta.type == "link"}}
            <a href="{{? it.content.footer.sndCta.href}}{{=it.content.subTitle.heading}}{{??}}#{{?}}" class="${mainLinkClass} js-modal-second-cta">
            {{=it.content.footer.sndCta.label}}
            </a>
          {{??}}
            <button type="button" role="button" class="${mainButtonClass} ${mainButtonClass}--bordered js-modal-second-cta">
              <span class="${labelButtonClass}">
                {{=it.content.footer.sndCta.label}}
              </span>
            </button>
          {{?}}
        {{?}}
    </footer>
</div>
</div>
`;